import React, { useState } from "react";
// import "../App.css";
import ParallaxSection from '../components/ParallaxSection'
import LogoCarousel from "../components/LogoCarousel";
import SubBanner from "../components/SubBanner"
import HeartSection from "../components/Health/HeartSection";
import HeartBanner from "../components/Health/HeartBanner";
import SubStory from "../components/Health/SubStory"
import bgImage from "../Assets/agrotech/phoneagriculture.png";
import SubStone from "../components/Health/SubStone";
import SubFounder from "../components/Health/SubFounder";
import founderPhoto from '../Assets/foundation/smallboy.png'
import dotPattern from "../Assets/health/Ellipse 164.png";
import vcnrLogo from "../Assets/vcnr-logo-white.png";
import OutreachSection from "../components/Health/HealthcareCommunityOutreach";
import Img1 from "../Assets/foundation/img1.png";
import Img2 from "../Assets/foundation/img2.png";
import Img3 from "../Assets/foundation/img3.png";
import TestimonialSlider from "../components/Health/TestimonialSlider";
import testimonialbg from "../Assets//rock-bg.png"
import Subservicesmediacarousel from "../components/Health/Subservicesmediacarousel";
import foundationbanner from "../Assets/foundation/foundationbanner.png";
import StatisticsSection from "../components/StatisticsSection";
import statsBg from '../Assets/stats-bg.png';
import handheart from "../Assets/educational/edu_stone.png";
import health from "../Assets/foundation/health.png";
import education from "../Assets/foundation/education.png";
import women from "../Assets/foundation/women.png";
import Environmental from "../Assets/foundation/Environmental.png";
import Disaster from "../Assets/foundation/Disaster.png";
import SchoolCard from '../components/Foundation/SchoolCard';
import schoolBgImg from '../Assets/foundation/schoolBgImg.png';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from 'react-icons/fa';
import foundationheart from "../Assets/health/Ellipse 164.png"
import { Helmet } from "react-helmet-async";
import seoMeta from "./seoMeta";
import { useNavigate } from "react-router-dom";
import pulseLine from "../Assets/agrotech/lineright.png"
import TrustBanner from "../components/Foundation/TrustBanner"
import EducationalBanner from "../components/Foundation/EducationalBanner";

const Educational = () => {
  const meta = seoMeta["/educational"];
  const navigate=useNavigate();
const logos = [
  { src: require('../Assets/LOGO/client1.png'), alt: 'Nestle' },
  { src: require('../Assets/LOGO/client2.png'), alt: 'Godrej' },
  { src: require('../Assets/LOGO/client3.png'), alt: 'Bajaj' },
  { src: require('../Assets/LOGO/client4.png'), alt: 'Reliance' },
  { src: require('../Assets/LOGO/client5.png'), alt: 'Safexpress' },
  { src: require('../Assets/LOGO/client6.png'), alt: 'JWL' },
  { src: require('../Assets/LOGO/client7.png'), alt: 'GIRIAS' },
  { src: require('../Assets/LOGO/client8.png'), alt: 'Nestle' },
    { src: require('../Assets/LOGO/client9.png'), alt: 'Denso' },
      { src: require('../Assets/LOGO/client10.png'), alt: 'Britania' },
        { src: require('../Assets/LOGO/client11.png'), alt: 'fsc' },
          { src: require('../Assets/LOGO/client12.png'), alt: 'ITC' },
            { src: require('../Assets/LOGO/client13.png'), alt: 'scope' },
            { src: require('../Assets/LOGO/client14.png'), alt: 'Flipkart' },
          ];
const paragraphs = [
    `We are committed to providing English-medium, value-driven education for underprivileged children, ensuring that every child has access to quality learning opportunities. Our approach focuses on holistic development, offering state-of-the-art STEM labs, arts, sports, and skill-building programs that nurture creativity, critical thinking, and overall growth. We strive to create an inclusive learning environment for differently-abled students, where diversity is respected and every child can thrive. To remove barriers to education, we provide free schooling, uniforms, and nutritious midday meals, empowering children to learn with dignity and equal opportunity.`,
    `We offer professional nursing education that combines academic excellence with hands-on training in modern healthcare facilities, equipping students with the skills required to meet today’s medical challenges. Our programs are designed to prepare students to serve the healthcare needs of both rural and urban communities, ensuring quality care reaches every corner of society. With a strong emphasis on ethics, empathy, and excellence in healthcare, we nurture compassionate professionals who uphold the highest standards of service. To make education accessible, we also provide scholarships and financial support for deserving students, enabling them to pursue their dreams and contribute meaningfully to the healthcare sector.`,
  ];
  const paragraphs2 = [
    `At VCNR Agrotech, we bring together age old farming wisdom and modern innovation to empower farmers across the country. Whether it is a drone-based farming in India or carbon-credit cultivation pilots, our solutions are tested on the ground and guided by those who work it.`,
    `In partnership with universities and agri-tech startups, we create practical tools like AI-powered crop advisors and solar irrigation systems. Our goal: to make sustainable agriculture not just possible, but profitable for every farmer, everywhere.`,
    `By driving AI in farming across India, we are helping cultivate a future where technology supports tradition and every harvest tells a story of resilience.`
  ];
const paragraphs1 = [
  `We measure our success with the success stories of our patients. Through words, videos, and shared memories, We honor the strength of those who have healed with us. Their stories inspire our teams to go further.`
];
const healthcareCards = [
  { title: "Volunteer at a VCNR Health Camp Support outreach efforts and bring care to those in need.", image: Img1 },
  { title: "Sponser a student or family that brings change to their lives through education, healthcare, and opportunity", image: Img2 },
  { title: "Got skills in design, legal aid, tech support, agricultural expertise? Your talent counts.", image: Img3 },
  { title: "Volunteer at a VCNR Health Camp Support outreach efforts and bring care to those in need.", image: Img1 },
  { title: "Sponser a student or family that brings change to their lives through education, healthcare, and opportunity", image: Img2 },
  { title: "Got skills in design, legal aid, tech support, agricultural expertise? Your talent counts.", image: Img3 },
  { title: "Volunteer at a VCNR Health Camp Support outreach efforts and bring care to those in need.", image: Img1 },
  { title: "Sponser a student or family that brings change to their lives through education, healthcare, and opportunity", image: Img2 },
  { title: "Got skills in design, legal aid, tech support, agricultural expertise? Your talent counts.", image: Img3 },
];

const quickAccessCards = [
  {
    title: "Step Into Opportunity\nGet the Brochure",
    buttonText: "Download Recruitment Brochure",
    buttonLink: "#"
  },
  {
    title: "Turn Connections\ninto Commissions",
    buttonText: "Referral Program Info",
    buttonLink: "#",
  },
  {
    title: "Connecting Talent\nwith Opportunity",
    buttonText: "Contact VCNR HR Team",
    buttonLink: "#"
  },
  {
    title: "Stay Ahead. Get Hired.\nOn WhatsApp",
    buttonText: "Join Our WhatsApp Hiring Channel",
    buttonLink: "#"
  }
];

const aboutTestimonials = [
  {
    stars: 5,
    title: "Amazing Experience!",
    text: "The whole journey was seamless and smooth. Would recommend to everyone!",
    author: "Ravi Kumar",
    location: "India, Bangalore",
    img: "https://i.pravatar.cc/40?img=9",
  },
  {
    stars: 4,
    title: "Truly Professional",
    text: "The team was very helpful and knowledgeable. They guided us at every step and made sure we got the best outcome.",
    author: "Neha Patel",
    location: "India, Mumbai",
    img: "https://i.pravatar.cc/40?img=10",
  },
  {
    stars: 5,
    title: "Exceeded Expectations",
    text: "From the first call to the final delivery, everything was well-managed and executed beyond my expectations.",
    author: "Mohammed Irfan",
    location: "India, Hyderabad",
    img: "https://i.pravatar.cc/40?img=11",
  },
  {
    stars: 4,
    title: "Reliable Support",
    text: "Even after the service was completed, they stayed in touch and provided great support when needed.",
    author: "Divya Menon",
    location: "India, Kochi",
    img: "https://i.pravatar.cc/40?img=12",
  },
  {
    stars: 5,
    title: "Effortless Process",
    text: "The process was transparent and smooth. I didn’t feel stressed at all and was kept informed throughout.",
    author: "Ankit Sharma",
    location: "India, Delhi",
    img: "https://i.pravatar.cc/40?img=13",
  },
  {
    stars: 5,
    title: "Highly Recommended",
    text: "One of the best service providers I’ve come across. Their ethics, efficiency, and execution are remarkable.",
    author: "Kritika Jain",
    location: "India, Pune",
    img: "https://i.pravatar.cc/40?img=14",
  },
  {
    stars: 5,
    title: "Customer First Approach",
    text: "They truly put the customer first. Every need of ours was taken care of. Thank you for such a positive experience.",
    author: "Ramesh Babu",
    location: "India, Chennai",
    img: "https://i.pravatar.cc/40?img=15",
  },
  {
    stars: 4,
    title: "Smooth Collaboration",
    text: "We worked on a collaborative project and it went smoothly thanks to their clear communication and technical expertise.",
    author: "Sonal Kapoor",
    location: "India, Jaipur",
    img: "https://i.pravatar.cc/40?img=16",
  },
];

const servicesData = [
  {
    title: "Health & Wellness",
    description: "Rural health camps, elder care, nutrition drives",
    image: health,
    link: "https://www.hithachinthana.org/index.html"
  },
  {
    title: "Education & Skill Development",
    description: "Schools, scholarships, vocational training",
    image: education,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Women & Youth Empowerment",
    description: "Self-help groups, leadership workshops",
    image: women,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Environmental & Rural Livelihoods",
    description: "Sustainable agriculture, water conservation",
    image: Environmental,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Disaster Response & Relief",
    description: "Emergency aid, rehabilitation efforts",
    image: Disaster,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Health & Wellness",
    description: "Rural health camps, elder care, nutrition drives",
    image: health,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Education & Skill Development",
    description: "Schools, scholarships, vocational training",
    image: education,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Women & Youth Empowerment",
    description: "Self-help groups, leadership workshops",
    image: women,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Environmental & Rural Livelihoods",
    description: "Sustainable agriculture, water conservation",
    image: Environmental,
        link: "https://www.hithachinthana.org/index.html"

  },
  {
    title: "Disaster Response & Relief",
    description: "Emergency aid, rehabilitation efforts",
    image: Disaster,
        link: "https://www.hithachinthana.org/index.html"

  },
];

const stats = [
  { value: 50, suffix: '+', label: 'Health Camps held annually' },
  { value: 5000, suffix: '+', label: 'Students empowered through education' },
  { value: 200, suffix: '+', label: 'Scholarships awarded' },
  { value: 3, suffix: ',K+', label: 'Women trained in livelihood programs' },
  { value: 20, prefix: '₹', suffix: 'M+', label: 'in community investments' },
  { value: 100, suffix: '%', label: 'Recovery rates from disaster initiatives' },
];


  return (
    <>
    <Helmet>
                  <title>{meta.title}</title>
            <meta name="description" content={meta.description} />
            <meta name="keywords" content={meta.keywords} />
          </Helmet>
    <div className="section-wrapper">
      <EducationalBanner />
    {/* <HeartBanner 
      heading="Uplifting Humankind with <br />Purpose and Compassion."
      subtext=" VCNR Foundation is the heart of our purpose. From Rural development and wellness to education and sustainability, we create real change that uplifts humanity and empowers humankind."
      buttonText="Explore More"
      onButtonClick={() => window.open("https://www.hithachinthana.org", "_blank")}
      heartImageSrc={foundationheart}
      peopleImageSrc={foundationbanner}
      pulseLineSrc={pulseLine}
    /> */}
</div>
<ParallaxSection><SubStory
      title="Our Institutions:"
      subtitle="Hithachinthana School & VCNR Nursing College"
      paragraphs={paragraphs}
    /></ParallaxSection>

    <ParallaxSection><SubStone
  imageSrc={handheart}
  heading={<>Empowering Education, <br /> Building Futures</>}
  buttonText="About Us"
  onButtonClick={() => window.location.href = "/about"}
/></ParallaxSection>

<ParallaxSection><Subservicesmediacarousel
      title="Key Focus Areas Where We Make a Difference"
      services={servicesData}
    /></ParallaxSection>

<ParallaxSection><StatisticsSection
            stats={stats}
            heading={<>Influence <br/>  Impact You Can See and Feel</>}
            description="The change we make  is more than numbers, they are stories of resilience, confidence, and progress."
            backgroundImage={statsBg}
          />
          </ParallaxSection>
    <br /><br />
  <div style={{ textAlign: 'center', marginBottom: '2.5rem' }}>
    <h2 style={{ fontSize: '3rem', fontWeight: 300, margin: 0, textUnderlineOffset: '8px', color: '#fff', lineHeight: 1.5, marginBottom:'1.5rem' }}>
      Reviews & Testimonials
    </h2>
    <h3  className="section-subtitle">
      Stories of Transformation
    </h3>
    <p style={{ color: '#fff', fontSize: '1.15rem', maxWidth: 900, margin: '0 auto', marginBottom: '1.5rem', lineHeight: 1.4 }}>
      Meet the people behind the numbers. From a young girl now pursuing medical school to a farmer doubling his yield through our training, these are stories of courage, community, and collective growth
    </p>
  </div>

<TestimonialSlider
    testimonials={aboutTestimonials}
    backgroundImage={testimonialbg}
  />  

 
<LogoCarousel logos={[...logos, ...logos]} />




    </>
  );
};

export default Educational;
